// extracted by mini-css-extract-plugin
export default {"signup_card":"SignupPage_signup_card__L3rHd","header":"SignupPage_header__Vk44g"};